import { createTheme } from '@mui/material/styles';

export const darkBg = 'rgb(20, 20, 12)';
export const darkTxt = 'rgb(230, 227, 213)';
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: 'rgb(203, 203, 118)',
      contrastText: 'rgb(50, 50, 0)',
    },
    secondary: {
      main: 'rgb(202, 200, 165)',
      contrastText: 'rgb(50, 50, 24)',
    },
    tertiary: {
      main: 'rgb(164, 208, 189)',
      contrastText: 'rgb(11, 55, 42)',
    },
    error: {
      main: 'rgb(255, 180, 171)',
      contrastText: 'rgb(105, 0, 5)',
    },
    background: {
      default: 'rgb(20, 20, 12)',
      paper: 'rgb(20, 20, 12)',
    },
    surface: {
      main: 'rgb(20, 20, 12)',
      variant: 'rgb(72, 71, 58)',
      dim: 'rgb(20, 20, 12)',
      bright: 'rgb(58, 58, 48)',
      container: 'rgb(32, 32, 24)',
      containerLow: 'rgb(28, 28, 20)',
      containerHigh: 'rgb(43, 42, 34)',
    },
    text: {
      primary: 'rgb(230, 227, 213)',
      secondary: 'rgb(202, 199, 182)',
      disabled: 'rgb(147, 145, 130)',
      hint: 'rgb(202, 199, 182)',
    },
  },
  typography: {
    fontFamily: 'Comfortaa, sans-serif',
  },
  overrides: {
    MuiButton: {
      // Add button overrides if needed
    },
    // Add more overrides as needed
  },
});

export const lightBg = 'rgb(253, 249, 236)';
export const lightTxt = 'rgb(28, 28, 20)';
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: 'rgb(97, 97, 24)',
      contrastText: 'rgb(255, 255, 255)',
    },
    secondary: {
      main: 'rgb(96, 96, 67)',
      contrastText: 'rgb(255, 255, 255)',
    },
    tertiary: {
      main: 'rgb(61, 102, 87)',
      contrastText: 'rgb(255, 255, 255)',
    },
    error: {
      main: 'rgb(186, 26, 26)',
      contrastText: 'rgb(255, 255, 255)',
    },
    background: {
      default: 'rgb(253, 249, 236)',
      paper: 'rgb(253, 249, 236)',
    },
    surface: {
      main: 'rgb(253, 249, 236)',
      variant: 'rgb(230, 227, 209)',
      dim: 'rgb(221, 218, 205)',
      bright: 'rgb(253, 249, 236)',
      container: 'rgb(241, 238, 224)',
      containerLow: 'rgb(247, 244, 230)',
      containerHigh: 'rgb(236, 232, 219)',
    },
    text: {
      primary: 'rgb(28, 28, 20)',
      secondary: 'rgb(72, 71, 58)',
      disabled: 'rgb(121, 120, 105)',
      hint: 'rgb(202, 199, 182)',
    },
  },
  typography: {
    fontFamily: 'Comfortaa, sans-serif',
  },
  overrides: {
    MuiButton: {},
  },
});
